import React, { useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Form, Spin, Upload } from 'antd';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import Request from 'common/network/Request';

const UploadImages = ({
  control,
  setError,
  errors,
  data = {},
  onUploading,
}) => {
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (options, onUploadSuccess) => {
    if (_.get(data.images, 'length', 0) >= 2) {
      setError('images', {
        type: 'manual',
        message: 'Chỉ được tải lên tối đa 2 ảnh!',
      });
      return;
    }
    setUploading(true);
    onUploading(true);
    const { onSuccess, file, onProgress } = options;

    try {
      let result;

      result = await Request.post(
        '/sale/upload-file',
        {
          upload_file: file,
          uploadFileField: 'upload_file',
        },
        {
          onUploadProgress: (event) => {
            if (event.loaded == event.total) {
              onSuccess({ percent: (event.loaded / event.total) * 100 }, file);
            } else {
              onProgress({ percent: (event.loaded / event.total) * 100 }, file);
            }
          },
        },
      );

      if (result.success) {
        let fileData = {
          uid: file.uid,
          id: result.result.id,
          name: result.result.name,
          status: 'done',
          // path tương đối: giá trị gửi lên khi lưu ứng viên / buổi gặp
          path: result.result.path,
          // url đã ký từ BE: route sale_images yêu cầu chữ ký nên chỉ url này preview được
          url: result.result.url,
        };

        onUploadSuccess(_.concat(data.images, [fileData]).filter(Boolean));
      }
    } catch (error) {
      console.error(error);
    }

    setUploading(false);
    onUploading(false);
  };

  const fileList = useMemo(() => {
    // url từ BE đã là absolute + có chữ ký — dùng trực tiếp, không tự ghép host/path
    return !_.isEmpty(data.images) ? [...data.images] : [];
  }, [data.images]);

  return (
    <Form.Item
      label="Ảnh đính kèm"
      validateStatus={errors.images ? 'error' : ''}
      help={errors.images?.message}
    >
      <Controller
        control={control}
        name="images"
        render={({ field }) => {
          return (
            <Spin spinning={uploading}>
              <Upload
                customRequest={(options) => uploadFile(options, field.onChange)}
                onRemove={(value) => {
                  field.onChange(
                    _.filter(field.value, (val) => val.uid !== value.uid),
                  );
                }}
                defaultFileList={[]}
                multiple={false}
                listType="picture-card"
                fileList={fileList}
                maxCount={2}
                accept="image/jpg,image/png,image/jpeg"
                className={twMerge(
                  clsx(
                    '[&_.ant-upload-list-item-container]:!h-[165px] [&_.ant-upload-list-item-container]:!flex-1',
                    _.get(field.value, 'length', 0) >= 2 &&
                      '[&_.ant-upload-select]:!hidden',
                  ),
                )}
              >
                {'+ Tải lên'}
              </Upload>
            </Spin>
          );
        }}
      />
    </Form.Item>
  );
};

export default UploadImages;
